/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-17, 13:00:40
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-23, 11:54:26
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { mapActions, mapGetters } from 'vuex';
import { hMapCollectionByCondition, hCompareTwoArraysAndReturnDifference } from '@/utils/helpers';
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'RodoTerms',
  components: { Card },

  props: [],

  data() {
    return {
      selectedTerms: [],
      requiredTerms: [],
    };
  },

  created() {
    this.getRodoTerms();
  },

  computed: {
    ...mapGetters(['shouldShowRodoTerms', 'rodoTerms']),
  },

  methods: {
    ...mapActions(['getRodoTerms', 'logOut', 'sendAcceptedTerms']),
    __reloadPage() {
      window.location.reload();
    },
    __validateRequiredTerms() {
      const termsThatShouldBeSelected = hMapCollectionByCondition(
        this.rodoTerms,
        'id',
        { required: true },
      );

      this.requiredTerms = hCompareTwoArraysAndReturnDifference(
        termsThatShouldBeSelected,
        this.selectedTerms,
      );
    },
    cancelTerms() {
      this.logOut()
        .then(() => {
          this.__reloadPage();
        });
    },
    submitTermsForm() {
      this.__validateRequiredTerms();
      if (this.requiredTerms.length === 0) {
        this.sendAcceptedTerms(this.selectedTerms);
      } else {
        this.$toaster.error('Nie wszystkie wymagane pola zostały zaznaczone.');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/RodoTerms/component.js